import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../../assets/logo.png";
import { API_BASE_URL } from "../../../config";

function PoolCareSwapListings() {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth <= 768);
  };

  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

  const [swaps, setSwaps] = useState([]);
  const [loading, setLoading] = useState(true);

  const [filters, setFilters] = useState({
    category: "Pool Care",
    view: "swaps",
    state: "",
    postcode: "",
  });



  const categoryOptions = [
    { label: "Lawn Mowing", path: "/swaps" },
    { label: "Cleaning", path: "/cleaning/swaps" },
    { label: "Pool Care", path: "/poolcare/swaps" },
  ];

  const viewOptions = [
    { label: "Buy Clients", path: "/poolcare/listings" },
    { label: "Swap Clients", path: "/poolcare/swaps" },
  ];

  const states = ["NSW", "VIC", "QLD", "SA", "WA", "TAS", "NT", "ACT"];

  useEffect(() => {
    async function loadSwaps() {
      try {
        const res = await fetch(
          `${API_BASE_URL}/api/poolcare/swap-listings`
        );
        const data = await res.json();
        setSwaps(data.listings || []);
      } catch (err) {
        console.error("❌ Failed to load pool care swaps:", err);
        setSwaps([]);
      } finally {
        setLoading(false);
      }
    }

    loadSwaps();
}, []);

  const filteredSwaps = swaps.filter((s) => {
 if (s.hidden === 1) return false;
if (s.expired === 1) return false;

if (
  s.swap_status === "completed" ||
  s.swap_status === "expired"
) {
  return false;
}

    if (filters.state && s.state !== filters.state) return false;
    if (
      filters.postcode &&
      !String(s.postcode || "").includes(filters.postcode)
    )
      return false;

    return true;
  });

  if (loading) {
    return <p style={{ padding: 20 }}>Loading pool care swaps…</p>;
  }

  return (
<div
  style={{
    display: "flex",
    flexDirection: isMobile ? "column" : "row",
    minHeight: "100vh",
    overflow: "hidden",
    backgroundColor: "#f4f7f9",
  }}
>
      {/* SIDEBAR */}
<aside
style={{
  width: isMobile ? "100%" : "250px",
  backgroundColor: "#2e7d32",
  color: "#fff",
  padding: isMobile ? "4px 6px" : "20px",
  height: isMobile ? "auto" : "100vh",
  overflowY: isMobile ? "visible" : "auto",
  textAlign: "center",
}}
>
        <img src={logo} alt="Client Exchange" style={{ width: 140 }} />

        {/* CATEGORY SELECT */}
        <label style={{ fontWeight: "bold", marginTop: 20, display: "block" }}>
          Category
        </label>
        <select
          value={filters.category}
          onChange={(e) => {
            const selected = e.target.value;
            setFilters({ ...filters, category: selected });

            const target = categoryOptions.find(
              (c) => c.label === selected
            );
            if (target) navigate(target.path);
          }}
          style={inputStyle}
        >
          {categoryOptions.map((c) => (
            <option key={c.label} value={c.label}>
              {c.label}
            </option>
          ))}
        </select>

        {/* VIEW SELECT */}
        <label style={{ fontWeight: "bold" }}>View</label>
        <select
          value={filters.view}
          onChange={(e) => {
            const selected = e.target.value;
            setFilters({ ...filters, view: selected });

            const target = viewOptions.find(
              (v) => v.label === selected
            );
            if (target) navigate(target.path);
          }}
          style={inputStyle}
        >
          {viewOptions.map((v) => (
            <option key={v.label} value={v.label}>
              {v.label}
            </option>
          ))}
        </select>

        {/* STATE */}
        <label style={{ fontWeight: "bold" }}>State</label>
        <select
          value={filters.state}
          onChange={(e) =>
            setFilters({ ...filters, state: e.target.value })
          }
          style={inputStyle}
        >
          <option value="">All</option>
          {states.map((s) => (
            <option key={s} value={s}>
              {s}
            </option>
          ))}
        </select>

        {/* POSTCODE */}
        <label style={{ fontWeight: "bold" }}>Postcode</label>
        <input
          type="text"
          value={filters.postcode}
          onChange={(e) =>
            setFilters({ ...filters, postcode: e.target.value })
          }
          placeholder="Enter postcode"
          style={inputStyle}
        />
        <button
  onClick={() => {
    setFilters({
      category: "Pool Care",
      view: "Swap Clients",
      state: "",
      postcode: "",
    });
    navigate("/poolcare/swaps");
  }}
  style={{
    width: "100%",
    padding: "12px",
    backgroundColor: "#d32f2f",
    color: "#fff",
    border: "none",
    borderRadius: "8px",
    cursor: "pointer",
    fontWeight: "bold",
    marginTop: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
  }}
>
  Reset Filters
</button>
      </aside>

      {/* MAIN */}
 <main
  style={{
    flex: 1,
    minWidth: 0,
    padding: isMobile ? "12px" : "25px",
    overflowY: "auto",
    height: isMobile ? "auto" : "100vh",
  }}
>
        <h2 style={{ color: "#2e7d32" }}>
          Pool Care Swap Listings ({filteredSwaps.length})
        </h2>

        <div
  style={{
    textAlign: "center",
    background: "#eef8f0",
    border: "1px solid #cfe8d3",
    borderRadius: "12px",
    padding: "14px 18px",
    margin: "0 auto 20px",
    maxWidth: "700px",
    color: "#1b5e20",
    fontWeight: "700",
  }}
>
  🚀 Soft Launch: Be among the first contractors to list on Client Exchange.
</div>

        {filteredSwaps.length === 0 ? (
          <p>No pool care swaps available.</p>
        ) : (
          <div style={grid}>
            {filteredSwaps.map((s) => (
              <div key={s.listingId} style={card}>
              {(s.swap_status === "available" ||
  s.swap_status === "locked" ||
  s.swap_status === "handover") && (
  <div
    style={{
      position: "absolute",
      top: 12,
      left: 12,
      padding: "4px 10px",
      borderRadius: 12,
      fontSize: 12,
      fontWeight: "bold",
      zIndex: 2,
      color: "#fff",
      background:
        s.swap_status === "available"
          ? "#2e7d32"     // green
          : s.swap_status === "locked"
          ? "#f9a825"     // amber
          : "#fb8c00",    // orange
    }}
  >
    {s.swap_status === "available" && "Available"}
    {s.swap_status === "locked" && "Swap In Progress"}
    {s.swap_status === "handover" && "Handover In Progress"}
  </div>
)}


                <img
                  src="/images/poolcare.jpg"
                  alt="Pool Care Swap"
                  style={cardImage}
                />

<div style={{ padding: "12px 15px" }}>
  <h2
    style={{
      margin: "0 0 4px 0",
      color: "#333",
      fontSize: "1.1rem",
      fontWeight: "600",
    }}
  >
    Swap – Pool Care
  </h2>

  <p
    style={{
      margin: "0 0 8px 0",
      color: "#777",
      fontSize: "0.8rem",
    }}
  >
    ID: <strong>{s.listingId}</strong>
  </p>

  <div
    style={{
      display: "grid",
      gridTemplateColumns: "1fr 1fr",
      rowGap: "6px",
      fontSize: "0.9rem",
    }}
  >
    <div>
      <strong>From:</strong> {s.swap_from_suburb} {s.swap_from_postcode}
    </div>

    <div style={{ textAlign: "right" }}>
      <strong>To:</strong> {s.swap_to_suburb} {s.swap_to_postcode}
    </div>

    <div>
  🕒 {s.serviceTime || "Any Time"}
</div>

    <div style={{ textAlign: "right" }}>
  <span style={{ marginRight: 6 }}>📅</span>
  <strong>{s.frequency}</strong>
</div>

    <div style={{ color: "#2e7d32", fontWeight: "bold" }}>
      Client Pays: ${Number(s.serviceFee || 0).toFixed(2)}
    </div>
  </div>

  <Link
    to={`/poolcare/swaps/${s.listingId}`}
    style={viewBtn}
  >
    View Details
  </Link>
</div>
              </div>
            ))}
          </div>
        )}
      </main>
    </div>
  );
}

/* STYLES */
const inputStyle = {
  width: "100%",
  padding: 10,
  marginBottom: 12,
  borderRadius: 6,
  border: "1px solid #ccc",
};
const grid = {
  display: "grid",
  gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
  gap: 20,
};
const card = {
  position: "relative", // 👈 REQUIRED for badge overlay
  background: "#fff",
  borderRadius: 12,
  boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
  overflow: "hidden",
};

const cardImage = {
  width: "100%",
  height: 200,
  objectFit: "cover",
};

const badge = {
  display: "inline-block",
  background: "#e8f5e9",
  color: "#2e7d32",
  padding: "4px 8px",
  borderRadius: 6,
  fontSize: 12,
  fontWeight: "bold",
};

const viewBtn = {
  display: "block",
  width: "100%",
  marginTop: 8,
  textAlign: "center",
  padding: 10,
  background: "#2e7d32",
  color: "#fff",
  borderRadius: 6,
  textDecoration: "none",
  fontWeight: "bold",
};

export default PoolCareSwapListings;
